import moment from "moment";

import { authGet } from "@api";
import { TimeLookbackRange } from "@types";
import { calculateLookbackSeconds } from "@utils/calculateLookbackSeconds";

import { ProjectAnalyticsResponse } from "@pages/overview/types";

export const fetchProjectStats = (
  deploymentId: string,
  timeLookbackRange: TimeLookbackRange,
  reposFilter: string[],
  until: number = moment().unix()
): Promise<ProjectAnalyticsResponse> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  const reposParam =
    reposFilter.length > 0 ? `&repo=${reposFilter.join(",")}` : "";
  return authGet<ProjectAnalyticsResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/projects?since=${since}&until=${until}${reposParam}`
  );
};
